import { FormLabel, Grid, Input, Stack } from '@chakra-ui/react'
import type { AdditionVehicle, InsuranceParamsTravelDto, OfferTravel, OfferTravelAddition, PackageItemModel } from 'BrokerTsLib/src/dtos'
import { useEffect, useRef } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useInsuranceParamsContext } from '../../../../../layouts/Wizard'

type VehiclesProps = {
    offer: OfferTravel
    addon: PackageItemModel
}

const getDefaultItem = (addon: PackageItemModel, licensePlate?: string) => {
    const defaultVariant = addon.variants.find(x => x.isDefault) ?? addon.variants[0]

    return {
        riskId: addon.riskId,
        packageItemId: addon.packageItemId,
        variantId: defaultVariant?.id,
        limit: defaultVariant?.defaultLimit?.toString(),
        registrationMark: licensePlate ?? ''
    } as AdditionVehicle
}

function Vehicles({
    offer,
    addon
}: VehiclesProps) {

    const { insuranceParams } = useInsuranceParamsContext()
    const ipt = insuranceParams as InsuranceParamsTravelDto

    const {
        control,
        setValue
    } = useFormContext<OfferTravelAddition>()

    const name = 'vehicles'

    const { append, fields, remove } = useFieldArray({
        control: control,
        name: name
    })

    // kvuli zachovani informace pri strictMode, kdy se kvuli mount a unmout vychozi prvek pridaval 2x
    const initializedRef = useRef(false)

    // vychozi nastaveni hodnot na OfferTravelAddition z OfferPart
    useEffect(() => {
        if (initializedRef.current) return

        fields.forEach((item, index) => {
            const part = offer.parts.find(x => x.partId == item.offerPartId)
            if (!part) return

            setValue(`${name}.${index}.riskId`, part.packageItem?.riskId)
            setValue(`${name}.${index}.limit`, part.limit?.toString())
            setValue(`${name}.${index}.variantId`, part.packageItemVariantId)
            setValue(`${name}.${index}.offerPartId`, part.partId)
            setValue(`${name}.${index}.packageItemId`, part.packageItem?.packageItemId)
        })

        if (fields.length == 0)
            append(getDefaultItem(addon, ipt.addons.vehicleRegistrationMark))

        initializedRef.current = true
    }, [])

    return (
        <Grid gap={8} gridTemplateColumns='1fr'>
            {fields?.map((item, index) => {
                return <VehicleItem
                    key={`${item.offerPartId}_${index}`}
                    index={index}
                    item={item}
                />
            })}
        </Grid >
    )
}

export default Vehicles

type VehicleItemProps = {
    item: AdditionVehicle,
    index: number,
}

const VehicleItem = ({
    item,
    index
}: VehicleItemProps) => {

    const name = 'vehicles'
    const { register, watch, setValue } = useFormContext<OfferTravelAddition>()

    return (
        <Stack key={`${item.offerPartId}_${index}`} alignSelf='start' minW='120px'>
            <FormLabel alignSelf='center'>Registrační značka</FormLabel>

            <Input
                size='sm'
                placeholder="### ####"
                {...register(`${name}.${index}.registrationMark`, {
                    onChange: (e) => {
                        setValue(`${name}.${index}.registrationMark`, e.target.value.toUpperCase())
                    }
                })}
            />
        </Stack>
    )
}
